import { Component, OnInit, ViewChild } from '@angular/core';
import { TransactionService } from '../../../../services/transaction.service';
import { Transaction, TransactionItem, TransactionItemUpdate, TransactionResponse } from '../../../../model/Transaction';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { PDF } from 'app/utils/pdf';
import Swal from "sweetalert2";
import { pdfTiqueteTransaccionTemplate } from 'app/templates/pdf-export/tiquete-transaccion';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-transaction-list',
  templateUrl: './transaction-list.component.html',
  styleUrls: ['./transaction-list.component.css']
})
export class TransactionListComponent implements OnInit {
  transactions: Transaction[] = [];
  loading = false;
  error: string | null = null;
  filterDate: string = '';
  filterContainer: string = '';
  filterStatus: string = '';
  user: any;
  formTransaction: FormGroup;
  @ViewChild("content") myModal;
  @ViewChild("formTransactionModal") formTransactionModal;
  params: any = {
    page: 1,
    hasNextPage: false,
    hasPreviousPage: false,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0
  };
  activeTab: string = 'storage';
  transaction: TransactionResponse | null = null;
  transactionItem: TransactionItem | null = null;
  transactionUpdate: TransactionItemUpdate | null = null;
  containerTypes: any[] = [];

  constructor(private transactionService: TransactionService, 
    private modalService: NgbModal, 
    private formBuilder: FormBuilder,
    private pdf: PDF, private spinner: NgxSpinnerService) { 
    this.formTransaction = this.formBuilder.group({
      container: [''],
      driverName: [''],
      driverId: [''],
      driverPhone: [''],
      vehiclePlate: [''],
      description: [''],
      containerTypeId: [''],
      transactionType: [''],
      discount: [0,''],
    });
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.fetchContainerTypes();
    this.fetchTransactions();
  }

  fetchTransactions(): void {
    this.spinner.show();
    this.loading = true;
    this.params = {
      page: this.params.page,
      date: this.filterDate,
      container: this.filterContainer,
      status: this.activeTab === 'storage' ? this.filterStatus : '',
      transactionType: this.activeTab,
      limit: this.params.itemsPerPage,
    };
    this.transactionService.getTransactions(this.params).subscribe({
      next: (res) => {
        this.transactions = res.data || [];
        this.loading = false;
        this.spinner.hide();
        this.params.page = res.currentPage || 1;
        this.params.hasNextPage = res.hasNextPage || false;
        this.params.hasPreviousPage = res.hasPreviousPage || false;
        this.params.itemsPerPage = res.itemsPerPage || 10;
        this.params.totalItems = res.totalItems || 0;
        this.params.totalPages = res.totalPages || 0;
      },
      error: (err) => {
        this.error = 'Error al cargar transferencias';
        this.loading = false;
        this.spinner.hide();
      }
    });
  }

  fetchContainerTypes(): void {
    this.spinner.show();
    this.loading = true;
    this.transactionService.getContainerTypes().subscribe({
      next: (res) => {
        this.containerTypes = res || [];
        this.spinner.hide();
      },
      error: (err) => {
        this.error = 'Error al cargar tipos de contenedor';
        this.spinner.hide();
      }
    });
  }

  confirmTransaction(id: number): void {
    Swal.fire({
      title: 'Confirmar checkout',
      text: "Registre con qué transporte se retira el contenedor",
      icon: 'warning',
      // Un solo select de tres opciones en vez de una pregunta sí/no más
      // otro select: un clic menos y no permite el estado contradictorio
      // "no requiere transporte pero es de Piki 7".
      input: 'select',
      inputOptions: {
        ninguno: 'No requiere transporte',
        piki7: 'Transporte Piki 7',
        externo: 'Transporte Externo'
      },
      inputPlaceholder: 'Seleccione una opción',
      // El backend también lo exige; esto solo evita el viaje.
      inputValidator: (valor) => !valor ? 'Debe registrar el transporte para hacer checkout' : null,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, confirmar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.transactionService.checkoutTransaction(id, result.value).subscribe({
          next: (res) => {
            this.transaction = res;
            this.toggleModal(this.myModal);
          },
          error: (err) => {
            this.error = 'Error al confirmar checkout';
            this.spinner.hide();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se pudo confirmar el checkout',
              showConfirmButton: false,
              timer: 1500
            });
          },
          complete: () => {
            this.spinner.hide();
            Swal.fire({
              icon: 'success',
              title: 'Checkout confirmado',
              showConfirmButton: false,
              timer: 1500
            });
            this.fetchTransactions();
          } 
        });
      }
    });
  }

  cancelTransaction(id: number): void {
    Swal.fire({
      title: 'Anular transacción',
      text: "¿Estás seguro de que deseas anular esta transacción?",
      icon: 'warning',
      showCancelButton: true,
      cancelButtonColor: '#3085d6',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Sí, anular',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.transactionService.cancelTransaction(id).subscribe({
          next: (res) => {},
          error: (err) => {
            this.error = 'Error al anular transacción';
            this.spinner.hide();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se pudo anular la transacción',
              showConfirmButton: false,
              timer: 1500
            });
          },
          complete: () => {
            this.spinner.hide();
            Swal.fire({
              icon: 'success',
              title: 'Transacción anulada',
              showConfirmButton: false,
              timer: 1500
            });
            this.fetchTransactions();
          }
        });
      }
    });
  }

  clearFilters(): void {
    this.filterDate = '';
    this.filterContainer = '';
    this.filterStatus = '';
    this.params.page = 1;
    this.params.hasNextPage = false;
    this.params.hasPreviousPage = false;
    this.params.itemsPerPage = 10;
    this.params.totalItems = 0;
    this.params.totalPages = 0;
    this.fetchTransactions();
  }

  getTransaction(id: number): void {
    this.transactionService.calculateAmount(id).subscribe({
      next: (res) => {
        this.transaction = res;
        this.toggleModal(this.myModal);
      },
      error: (err) => {
        this.error = 'Error al obtener transacción';
      }
    });
  }

  cancelModal() {
    this.transaction = null;
    this.modalService.dismissAll();
  }

  async genPdf() {
    this.spinner.show();
    const docDefinition = await pdfTiqueteTransaccionTemplate(this.transaction);
    this.pdf.exportAsPDFFile2(docDefinition, "Tiquete");
    this.spinner.hide();
    this.fetchTransactions();
    this.cancelModal();
  }

  onSubmit() {
    if (this.formTransaction.valid) {
      const transactionData: TransactionItem = this.formTransaction.value;
      transactionData.containerTypeId = parseInt(this.formTransaction.value.containerTypeId, 10);
      this.spinner.show();
      if (this.transactionUpdate) {
        // Update existing transaction
        if (this.transactionUpdate.transactionType === 'storage'){
          this.transactionService.updateTransaction(this.transactionUpdate.id, transactionData).subscribe({
            next: (res) => {
              Swal.fire({
                icon: 'success',
                title: 'Transacción actualizada',
                showConfirmButton: false,
                timer: 1500
              });
              this.fetchTransactions();
              this.cancelModal();
              this.transaction = res;
              this.spinner.hide();
              this.formTransaction.reset();
              this.transactionUpdate = null;
              this.toggleModal(this.myModal);
            },
            error: (err) => {
              this.error = 'Error al actualizar transacción';
              this.spinner.hide();
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo actualizar la transacción',
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        } else {
          this.transactionService.updateTransactionTrans(this.transactionUpdate.id, transactionData).subscribe({
            next: (res) => {
              Swal.fire({
                icon: 'success',
                title: 'Transacción actualizada',
                showConfirmButton: false,
                timer: 1500
              });
              this.fetchTransactions();
              this.cancelModal();
              this.transaction = res;
              this.spinner.hide();
              this.formTransaction.reset();
              this.transactionUpdate = null;
              this.toggleModal(this.myModal);
            },
            error: (err) => {
              this.error = 'Error al actualizar transacción';
              this.spinner.hide();
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo actualizar la transacción',
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      } else {
        this.transactionService.createTransaction(transactionData).subscribe({
        next: (res) => {
          Swal.fire({
            icon: 'success',
            title: 'Transacción creada',
            text: 'La transacción se ha creado correctamente.',
            showConfirmButton: false,
            timer: 500
          });
          this.transaction = res;
          this.spinner.hide();
          this.fetchTransactions();
          this.formTransaction.reset();
          this.modalService.dismissAll();
          this.toggleModal(this.myModal);
        },
        error: (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `No se pudo crear la transacción. ${err.error.error || ''}`,
            showConfirmButton: false,
            timer: 1000
          });
          this.spinner.hide();
        }
      });
      }
    } else {
      console.log('Formulario inválido', this.formTransaction);
      
      Swal.fire({
        icon: 'warning',
        title: 'Formulario incompleto',
        text: 'Por favor, completa todos los campos requeridos.',
        showConfirmButton: false,
        timer: 1000
      });
      this.formTransaction.markAllAsTouched(); // Mark all controls as touched to show validation errors
    }
  }

  toggleModal(modal: any): void {
    this.modalService.open(modal);
  }

  updateModal(transaction: TransactionItemUpdate): void {
    this.transactionUpdate = transaction;
    this.formTransaction.patchValue({
      container: transaction.container,
      driverName: transaction.driverName,
      driverId: transaction.driverId,
      driverPhone: transaction.driverPhone,
      vehiclePlate: transaction.vehiclePlate,
      description: transaction.description,
      containerTypeId: transaction.containerTypeId,
      transactionType: transaction.transactionType,
      discount: transaction.discount || 0
    });
    this.toggleModal(this.formTransactionModal);
  }

  goToPage(page: number): void {
    this.params.page = page;
    this.fetchTransactions();
  }
}
